import { Rnd } from "react-rnd";
import "./ResizeableElement.css"; // Ensure you have this CSS file for styling
import { useEffect, useState } from "react";
const ResizeableElement = ({
  children,
  isEditEnabled,
  onSelect = () => {},
  defaultSize = { width: 400, height: 120 },
  defaultPosition = { x: 0, y: 0 },
  onChange = () => {},
}) => {
  const [size, setSize] = useState(defaultSize);
  const [position, setPosition] = useState(defaultPosition);

  const [showDetails, setShowDetails] = useState(false);
  const handleDoubleClick = (e) => {
    if (e.target.tagName === "INPUT") {
      // Prevent click event from propagating to the Rnd component
      e.stopPropagation();
      return;
    }
    if (isEditEnabled) {
      setShowDetails(!showDetails);
      onSelect(!showDetails);
    }
  };

  useEffect(() => {
    if (!isEditEnabled) {
      setShowDetails(false);
    }
  }, [isEditEnabled]);
  useEffect(() => {
    setPosition(defaultPosition);
  }, [defaultPosition]);
  useEffect(() => {
    setSize(defaultSize);
  }, [defaultSize]);

  const renderValues = () => (
    <div className="relm-values">
      <span>
        <b>W:</b> {size.width}
      </span>
      <span>
        <b>H:</b> {size.height}
      </span>
      <span>
        <b>X:</b> {position.x}
      </span>
      <span>
        <b>Y:</b> {position.y}
      </span>
    </div>
  );
  return (
    <Rnd
      onDoubleClick={handleDoubleClick}
      size={size}
      position={position}
      className={showDetails ? "relm-rnd relm-rnd-bg" : "relm-rnd"}
      onDragStop={(e, d) => {
        setPosition({ x: d.x, y: d.y });
        onChange({
          size: { width: size.width, height: size.height },
          position: { x: d.x, y: d.y },
        });
      }}
      onResize={(e, direction, ref, delta, position) => {
        setSize({
          width: ref.offsetWidth,
          height: ref.offsetHeight,
          ...position,
        });
        onChange({
          size: {
            width: ref.offsetWidth,
            height: ref.offsetHeight,
          },
          position: { x: position.x, y: position.y },
        });
      }}
    >
      <div className="relm-container">
        {children}
        {showDetails && renderValues()}
      </div>
    </Rnd>
  );
};
export default ResizeableElement;
